export { default } from './RenderStaticHTML';
